// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import "./Placeorder.css";

// const Placeorder = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [processingPayment, setProcessingPayment] = useState(false);

//   // Get selected items from cart
//   const { selectedItems, totalAmount, itemCount } = location.state || {
//     selectedItems: [],
//     totalAmount: 0,
//     itemCount: 0,
//   };

//   // Redirect if no items selected
//   useEffect(() => {
//     if (!selectedItems || selectedItems.length === 0) {
//       Swal.fire({
//         title: "No Items",
//         text: "Please select items from cart to place order.",
//         icon: "warning",
//         confirmButtonText: "Go to Cart",
//       }).then(() => {
//         navigate("/cart");
//       });
//     }
//   }, [selectedItems, navigate]);

//   // Form state
//   const [formData, setFormData] = useState({
//     guest_email: "",
//     shipping_address: {
//       address_type: "shipping",
//       name: "",
//       email: "",
//       mobile: "",
//       street: "",
//       city: "",
//       state: "",
//       postal_code: "",
//       country: "India",
//     },
//     billing_address: {
//       address_type: "billing",
//       name: "",
//       email: "",
//       mobile: "",
//       street: "",
//       city: "",
//       state: "",
//       postal_code: "",
//       country: "India",
//     },
//   });

//   // Same as shipping address toggle
//   const [sameAsShipping, setSameAsShipping] = useState(true);

//   // Load user data if available
//   useEffect(() => {
//     const userEmail = localStorage.getItem("username");
//     const userName = localStorage.getItem("username");

//     if (userEmail) {
//       setFormData((prev) => ({
//         ...prev,
//         guest_email: userEmail,
//         shipping_address: {
//           ...prev.shipping_address,
//           email: userEmail,
//           name: userName || "",
//         },
//       }));
//     }
//   }, []);

//   // Handle input changes
//   const handleInputChange = (e, section, field) => {
//     if (section === "guest") {
//       setFormData((prev) => ({
//         ...prev,
//         guest_email: e.target.value,
//       }));
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         [section]: {
//           ...prev[section],
//           [field]: e.target.value,
//         },
//       }));

//       // Update billing address if same as shipping
//       if (sameAsShipping && section === "shipping_address") {
//         setFormData((prev) => ({
//           ...prev,
//           billing_address: {
//             ...prev.billing_address,
//             [field]: e.target.value,
//           },
//         }));
//       }
//     }
//   };

//   // Handle same as shipping toggle
//   const handleSameAsShipping = (e) => {
//     setSameAsShipping(e.target.checked);
//     if (e.target.checked) {
//       setFormData((prev) => ({
//         ...prev,
//         billing_address: { ...prev.shipping_address, address_type: "billing" },
//       }));
//     }
//   };

//   // Load Razorpay script
//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   // Create order and initiate payment
//   const handlePlaceOrder = async (e) => {
//     e.preventDefault();

//     // Validate form
//     if (!validateForm()) return;

//     setLoading(true);

//     try {
//       // Prepare order data
//       const orderData = {
//         guest_email: formData.guest_email,
//         shipping_address: formData.shipping_address,
//         billing_address: sameAsShipping
//           ? formData.shipping_address
//           : formData.billing_address,
//         items: selectedItems.map((item) => ({
//           product_id: item.product_id,
//           price_id: item.price_id || item.id, // Adjust based on your data structure
//           quantity: item.quantity,
//         })),
//       };

//       const token = localStorage.getItem("accessToken");

//       // Create order
//       const orderResponse = await fetch(
//         "https://vogelkoparchitects.com/api/ecom/place-order/",
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(orderData),
//         },
//       );

//       if (!orderResponse.ok) {
//         throw new Error("Failed to create order");
//       }

//       const orderResult = await orderResponse.json();

//       // Load Razorpay and initiate payment
//       await initiateRazorpayPayment(orderResult);
//     } catch (error) {
//       console.error("Order placement error:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to place order. Please try again.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Initiate Razorpay payment
//   const initiateRazorpayPayment = async (orderData) => {
//     setProcessingPayment(true);

//     const scriptLoaded = await loadRazorpayScript();

//     if (!scriptLoaded) {
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to load payment gateway. Please try again.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       setProcessingPayment(false);
//       return;
//     }

//     // Razorpay options
//     const options = {
//       key: "YOUR_RAZORPAY_KEY_ID",
//       amount: totalAmount * 100,
//       currency: "INR",
//       name: "Vogelkop architecture",
//       description: `Order #${orderData.order_no}`,
//       order_id: orderData.razorpay_order_id, // If you have this from backend
//       handler: function (response) {
//         // Payment successful
//         handlePaymentSuccess(response, orderData);
//       },
//       prefill: {
//         name: formData.shipping_address.name,
//         email: formData.shipping_address.email,
//         contact: formData.shipping_address.mobile,
//       },
//       notes: {
//         address: formData.shipping_address.street,
//         order_no: orderData.order_no,
//       },
//       theme: {
//         color: "#3399cc",
//       },
//       modal: {
//         ondismiss: function () {
//           setProcessingPayment(false);
//           Swal.fire({
//             title: "Payment Cancelled",
//             text: "You have cancelled the payment. Your order is pending.",
//             icon: "info",
//             confirmButtonText: "OK",
//           });
//         },
//       },
//     };

//     const razorpay = new window.Razorpay(options);
//     razorpay.open();
//   };

//   // Handle payment success
//   const handlePaymentSuccess = async (paymentResponse, orderData) => {
//     try {
//       // Verify payment on backend
//       const token = localStorage.getItem("accessToken");

//       const verifyResponse = await fetch(
//         "https://vogelkoparchitects.com/api/ecom/verify-payment/",
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             order_no: orderData.order_no,
//             razorpay_payment_id: paymentResponse.razorpay_payment_id,
//             razorpay_order_id: paymentResponse.razorpay_order_id,
//             razorpay_signature: paymentResponse.razorpay_signature,
//           }),
//         },
//       );

//       if (verifyResponse.ok) {
//         Swal.fire({
//           title: "Success!",
//           text: `Order placed successfully! Order Number: ${orderData.order_no}`,
//           icon: "success",
//           confirmButtonText: "View Orders",
//         }).then(() => {
//           navigate("/orders"); // Navigate to orders page
//         });
//       } else {
//         throw new Error("Payment verification failed");
//       }
//     } catch (error) {
//       console.error("Payment verification error:", error);
//       Swal.fire({
//         title: "Payment Verification Failed",
//         text:
//           "Your payment was successful but we couldn't verify it. Please contact support with your order number: " +
//           orderData.order_no,
//         icon: "warning",
//         confirmButtonText: "OK",
//       });
//     } finally {
//       setProcessingPayment(false);
//     }
//   };

//   // Validate form
//   const validateForm = () => {
//     const { guest_email, shipping_address } = formData;

//     if (!guest_email) {
//       Swal.fire("Error", "Please enter email", "error");
//       return false;
//     }

//     if (
//       !shipping_address.name ||
//       !shipping_address.mobile ||
//       !shipping_address.street ||
//       !shipping_address.city ||
//       !shipping_address.state ||
//       !shipping_address.postal_code
//     ) {
//       Swal.fire("Error", "Please fill all shipping address fields", "error");
//       return false;
//     }

//     if (!sameAsShipping) {
//       const { billing_address } = formData;
//       if (
//         !billing_address.name ||
//         !billing_address.mobile ||
//         !billing_address.street ||
//         !billing_address.city ||
//         !billing_address.state ||
//         !billing_address.postal_code
//       ) {
//         Swal.fire("Error", "Please fill all billing address fields", "error");
//         return false;
//       }
//     }

//     return true;
//   };

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat("en-IN", {
//       style: "currency",
//       currency: "INR",
//       maximumFractionDigits: 0,
//     }).format(amount);
//   };

//   return (
//     <>
//       {" "}
//       <div className="cart-banner">
//         <img
//           src="/assets/img/ecommerce/banner/banner1.jpg"
//           alt="Shopping Cart Banner"
//           className="cart-banner-image"
//           onError={(e) => {
//             e.target.src =
//               "https://via.placeholder.com/1200x250?text=Shopping+Cart";
//           }}
//         />
//         <div className="cart-banner-overlay">
//           <div>
//             <h1 className="cart-banner-title">Place Your Order</h1>
//             <p className="cart-banner-subtitle">Place your Order here</p>
//           </div>
//         </div>
//       </div>
//       <div className="place-order-container">
//         <div className="place-order-header">
//           <h1>Place Your Order</h1>
//           <p>Complete your purchase by providing the details below</p>
//         </div>

//         <div className="place-order-content">
//           {/* Order Summary */}
//           <div className="order-summary-sidebar">
//             <h2>Order Summary</h2>
//             <div className="order-items">
//               {selectedItems.map((item) => (
//                 <div key={item.cart_item_id} className="order-item">
//                   <div className="order-item-image">
//                     <img
//                       src={item.image || "/api/placeholder/60/60"}
//                       alt={item.product_name}
//                     />
//                   </div>
//                   <div className="order-item-details">
//                     <h4>{item.product_name}</h4>
//                     <p>Qty: {item.quantity}</p>
//                     <p className="order-item-price">
//                       {formatCurrency(item.total_price)}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <div className="order-total">
//               <div className="total-row">
//                 <span>Subtotal ({itemCount} items)</span>
//                 <span>{formatCurrency(totalAmount)}</span>
//               </div>
//               <div className="total-row shipping">
//                 <span>Shipping</span>
//                 <span>Free</span>
//               </div>
//               <div className="total-row grand-total">
//                 <span>Total</span>
//                 <span>{formatCurrency(totalAmount)}</span>
//               </div>
//             </div>
//           </div>

//           {/* Address Form */}
//           <div className="address-form-container">
//             <form onSubmit={handlePlaceOrder}>
//               {/* Email Section */}
//               <div className="form-section">
//                 <h3>Contact Information</h3>
//                 <div className="form-group">
//                   <label>Email Address *</label>
//                   <input
//                     type="email"
//                     value={formData.guest_email}
//                     onChange={(e) => handleInputChange(e, "guest")}
//                     required
//                     placeholder="your@email.com"
//                   />
//                 </div>
//               </div>

//               {/* Shipping Address */}
//               <div className="form-section">
//                 <h3>Shipping Address</h3>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Full Name *</label>
//                     <input
//                       type="text"
//                       value={formData.shipping_address.name}
//                       onChange={(e) =>
//                         handleInputChange(e, "shipping_address", "name")
//                       }
//                       required
//                       placeholder="John Doe"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Mobile Number *</label>
//                     <input
//                       type="tel"
//                       value={formData.shipping_address.mobile}
//                       onChange={(e) =>
//                         handleInputChange(e, "shipping_address", "mobile")
//                       }
//                       required
//                       placeholder="9876543210"
//                       pattern="[0-9]{10}"
//                     />
//                   </div>
//                 </div>

//                 <div className="form-group">
//                   <label>Street Address *</label>
//                   <input
//                     type="text"
//                     value={formData.shipping_address.street}
//                     onChange={(e) =>
//                       handleInputChange(e, "shipping_address", "street")
//                     }
//                     required
//                     placeholder="123 Main St, Apartment 4B"
//                   />
//                 </div>

//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>City *</label>
//                     <input
//                       type="text"
//                       value={formData.shipping_address.city}
//                       onChange={(e) =>
//                         handleInputChange(e, "shipping_address", "city")
//                       }
//                       required
//                       placeholder="Mumbai"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>State *</label>
//                     <input
//                       type="text"
//                       value={formData.shipping_address.state}
//                       onChange={(e) =>
//                         handleInputChange(e, "shipping_address", "state")
//                       }
//                       required
//                       placeholder="Maharashtra"
//                     />
//                   </div>
//                 </div>

//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Postal Code *</label>
//                     <input
//                       type="text"
//                       value={formData.shipping_address.postal_code}
//                       onChange={(e) =>
//                         handleInputChange(e, "shipping_address", "postal_code")
//                       }
//                       required
//                       placeholder="400001"
//                       pattern="[0-9]{6}"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Country</label>
//                     <input
//                       type="text"
//                       value={formData.shipping_address.country}
//                       disabled
//                       className="disabled-input"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* Billing Address */}
//               <div className="form-section">
//                 <div className="checkbox-group">
//                   <label className="checkbox-label">
//                     <input
//                       type="checkbox"
//                       checked={sameAsShipping}
//                       onChange={handleSameAsShipping}
//                     />
//                     <span>Billing address same as shipping address</span>
//                   </label>
//                 </div>

//                 {!sameAsShipping && (
//                   <div className="billing-address-form">
//                     <h3>Billing Address</h3>
//                     <div className="form-row">
//                       <div className="form-group">
//                         <label>Full Name *</label>
//                         <input
//                           type="text"
//                           value={formData.billing_address.name}
//                           onChange={(e) =>
//                             handleInputChange(e, "billing_address", "name")
//                           }
//                           required
//                         />
//                       </div>
//                       <div className="form-group">
//                         <label>Mobile Number *</label>
//                         <input
//                           type="tel"
//                           value={formData.billing_address.mobile}
//                           onChange={(e) =>
//                             handleInputChange(e, "billing_address", "mobile")
//                           }
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="form-group">
//                       <label>Street Address *</label>
//                       <input
//                         type="text"
//                         value={formData.billing_address.street}
//                         onChange={(e) =>
//                           handleInputChange(e, "billing_address", "street")
//                         }
//                         required
//                       />
//                     </div>

//                     <div className="form-row">
//                       <div className="form-group">
//                         <label>City *</label>
//                         <input
//                           type="text"
//                           value={formData.billing_address.city}
//                           onChange={(e) =>
//                             handleInputChange(e, "billing_address", "city")
//                           }
//                           required
//                         />
//                       </div>
//                       <div className="form-group">
//                         <label>State *</label>
//                         <input
//                           type="text"
//                           value={formData.billing_address.state}
//                           onChange={(e) =>
//                             handleInputChange(e, "billing_address", "state")
//                           }
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="form-row">
//                       <div className="form-group">
//                         <label>Postal Code *</label>
//                         <input
//                           type="text"
//                           value={formData.billing_address.postal_code}
//                           onChange={(e) =>
//                             handleInputChange(
//                               e,
//                               "billing_address",
//                               "postal_code",
//                             )
//                           }
//                           required
//                         />
//                       </div>
//                       <div className="form-group">
//                         <label>Country</label>
//                         <input
//                           type="text"
//                           value={formData.billing_address.country}
//                           disabled
//                           className="disabled-input"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               {/* Action Buttons */}
//               <div className="form-actions">
//                 <button
//                   type="button"
//                   className="back-btn"
//                   onClick={() => navigate("/cart")}
//                   disabled={loading || processingPayment}
//                 >
//                   Back to Cart
//                 </button>
//                 <button
//                   type="submit"
//                   className="place-order-btn"
//                   disabled={loading || processingPayment}
//                 >
//                   {loading
//                     ? "Processing..."
//                     : processingPayment
//                       ? "Payment in Progress..."
//                       : `Pay ${formatCurrency(totalAmount)}`}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Placeorder;

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./Placeorder.css";

const Placeorder = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [processingPayment, setProcessingPayment] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const RAZORPAY_KEY_ID = "rzp_live_SN1YC66iO3hIlG";
  // Note: key_secret should never be used in frontend - only on backend

  // Get selected items from cart
  const { selectedItems, totalAmount, itemCount } = location.state || {
    selectedItems: [],
    totalAmount: 0,
    itemCount: 0,
  };

  // Redirect if no items selected
  useEffect(() => {
    if (!selectedItems || selectedItems.length === 0) {
      Swal.fire({
        title: "No Items",
        text: "Please select items from cart to place order.",
        icon: "warning",
        confirmButtonText: "Go to Cart",
      }).then(() => {
        navigate("/cart");
      });
    }
  }, [selectedItems, navigate]);

  // Form state matching the exact API structure
  const [formData, setFormData] = useState({
    items: [],
    shipping_address: {
      name: "",
      email: "",
      mobile: "",
      street: "",
      city: "",
      state: "",
      postal_code: "",
      country: "India",
    },
    billing_address: {
      name: "",
      email: "",
      mobile: "",
      street: "",
      city: "",
      state: "",
      postal_code: "",
      country: "India",
    },
  });

  // Same as shipping address toggle
  const [sameAsShipping, setSameAsShipping] = useState(true);

  // Load user data if available and set items
  useEffect(() => {
    const userEmail = localStorage.getItem("username");
    const userName = localStorage.getItem("username");

    // Format items for the API
    const formattedItems = selectedItems.map((item) => ({
      product_id: item.product_id,
      price_id: item.price_id || item.id,
      quantity: item.quantity,
    }));

    setFormData((prev) => ({
      ...prev,
      items: formattedItems,
      shipping_address: {
        ...prev.shipping_address,
        email: userEmail || "",
        name: userName || "",
      },
    }));
  }, [selectedItems]);

  // Handle input changes
  const handleInputChange = (e, addressType, field) => {
    const value = e.target.value;

    setFormData((prev) => ({
      ...prev,
      [addressType]: {
        ...prev[addressType],
        [field]: value,
      },
    }));

    // Update billing address if same as shipping
    if (sameAsShipping && addressType === "shipping_address") {
      setFormData((prev) => ({
        ...prev,
        billing_address: {
          ...prev.billing_address,
          [field]: value,
          email:
            addressType === "shipping_address" && field === "email"
              ? value
              : prev.billing_address.email,
        },
      }));
    }
  };

  // Handle same as shipping toggle
  const handleSameAsShipping = (e) => {
    const checked = e.target.checked;
    setSameAsShipping(checked);

    if (checked) {
      setFormData((prev) => ({
        ...prev,
        billing_address: { ...prev.shipping_address },
      }));
    }
  };

  // Load Razorpay script
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // Create order and initiate payment
  const handlePlaceOrder = async (e) => {
    e.preventDefault();

    // Validate form
    if (!validateForm()) return;

    setLoading(true);

    try {
      // Prepare order data according to the exact API specification
      const orderData = {
        items: formData.items,
        shipping_address: {
          name: formData.shipping_address.name,
          email: formData.shipping_address.email,
          mobile: formData.shipping_address.mobile,
          street: formData.shipping_address.street,
          city: formData.shipping_address.city,
          state: formData.shipping_address.state,
          postal_code: formData.shipping_address.postal_code,
          country: formData.shipping_address.country,
        },
        billing_address: sameAsShipping
          ? {
              name: formData.shipping_address.name,
              email: formData.shipping_address.email,
              mobile: formData.shipping_address.mobile,
              street: formData.shipping_address.street,
              city: formData.shipping_address.city,
              state: formData.shipping_address.state,
              postal_code: formData.shipping_address.postal_code,
              country: formData.shipping_address.country,
            }
          : {
              name: formData.billing_address.name,
              email: formData.billing_address.email,
              mobile: formData.billing_address.mobile,
              street: formData.billing_address.street,
              city: formData.billing_address.city,
              state: formData.billing_address.state,
              postal_code: formData.billing_address.postal_code,
              country: formData.billing_address.country,
            },
      };

      console.log(
        "Placing order with data:",
        JSON.stringify(orderData, null, 2),
      );

      const token = localStorage.getItem("accessToken");

      // Create order
      const orderResponse = await fetch(
        "https://vogelkoparchitects.com/api/ecom/place-order/",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(orderData),
        },
      );

      const orderResult = await orderResponse.json();
      console.log("Order response:", orderResult);

      if (!orderResponse.ok) {
        throw new Error(orderResult.message || "Failed to create order");
      }

      // If order is created successfully, initiate payment
      // Note: You might need to create a Razorpay order on your backend first
      // and include razorpay_order_id in the response
      await initiateRazorpayPayment(orderResult);
    } catch (error) {
      console.error("Order placement error:", error);
      Swal.fire({
        title: "Error!",
        text: error.message || "Failed to place order. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  // Initiate Razorpay payment
  // const initiateRazorpayPayment = async (orderData) => {
  //   setProcessingPayment(true);

  //   const scriptLoaded = await loadRazorpayScript();

  //   if (!scriptLoaded) {
  //     Swal.fire({
  //       title: "Error!",
  //       text: "Failed to load payment gateway. Please try again.",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //     setProcessingPayment(false);
  //     return;
  //   }

  //   try {
  //     const options = {
  //       key: "rzp_live_SN1YC66iO3hIlG",
  //       amount: totalAmount * 100, // Amount in paise
  //       currency: "INR",
  //       name: "Vogelkop Architects",
  //       description: `Order Payment`,
  //       // If your backend returns razorpay_order_id, use it here
  //       // order_id: orderData.razorpay_order_id,
  //       handler: function (response) {
  //         // Payment successful
  //         handlePaymentSuccess(response, orderData);
  //       },
  //       prefill: {
  //         name: formData.shipping_address.name,
  //         email: formData.shipping_address.email,
  //         contact: formData.shipping_address.mobile,
  //       },
  //       notes: {
  //         shipping_address: JSON.stringify(formData.shipping_address),
  //         order_id: orderData.id || orderData.order_no,
  //       },
  //       theme: {
  //         color: "#3399cc",
  //       },
  //       modal: {
  //         ondismiss: function () {
  //           setProcessingPayment(false);
  //           Swal.fire({
  //             title: "Payment Cancelled",
  //             text: "You have cancelled the payment. Your order is pending.",
  //             icon: "info",
  //             confirmButtonText: "OK",
  //           });
  //         },
  //       },
  //     };

  //     const razorpay = new window.Razorpay(options);
  //     razorpay.open();
  //   } catch (error) {
  //     console.error("Razorpay initiation error:", error);
  //     Swal.fire({
  //       title: "Payment Error",
  //       text: "Failed to initiate payment. Please try again.",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //     setProcessingPayment(false);
  //   }
  // };
  const initiateRazorpayPayment = async (orderData) => {
    setProcessingPayment(true);

    const scriptLoaded = await loadRazorpayScript();

    if (!scriptLoaded) {
      Swal.fire({
        title: "Error!",
        text: "Failed to load payment gateway. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setProcessingPayment(false);
      return;
    }

    try {
      const options = {
        key: orderData.razorpay_key || "rzp_live_SN1YC66iO3hIlG",
        amount: totalAmount * 100,
        currency: "INR",
        name: "Vogelkop Architects",
        description: `Order Payment`,
        order_id: orderData.razorpay_order_id, // Important: This comes from your backend
        handler: function (response) {
          console.log("Razorpay handler response:", response);
          // This response should contain ALL three fields
          handlePaymentSuccess(response, orderData);
        },
        prefill: {
          name: formData.shipping_address.name,
          email: formData.shipping_address.email,
          contact: formData.shipping_address.mobile,
        },
        notes: {
          shipping_address: JSON.stringify(formData.shipping_address),
          order_no: orderData.order_no,
        },
        theme: {
          color: "#3399cc",
        },
        modal: {
          ondismiss: function () {
            setProcessingPayment(false);
            Swal.fire({
              title: "Payment Cancelled",
              text: "You have cancelled the payment. Your order is pending.",
              icon: "info",
              confirmButtonText: "OK",
            });
          },
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("Razorpay initiation error:", error);
      Swal.fire({
        title: "Payment Error",
        text: "Failed to initiate payment. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setProcessingPayment(false);
    }
  };

  // Handle payment success
  // const handlePaymentSuccess = async (paymentResponse, orderData) => {
  //   try {
  //     setProcessingPayment(true);

  //     // Log payment response for debugging
  //     console.log("✅ Razorpay Payment Response:", paymentResponse);
  //     console.log("📦 Order Data:", orderData);

  //     // Validate payment response
  //     if (
  //       !paymentResponse.razorpay_payment_id ||
  //       !paymentResponse.razorpay_order_id ||
  //       !paymentResponse.razorpay_signature
  //     ) {
  //       throw new Error("Invalid payment response from Razorpay");
  //     }

  //     // Show processing message
  //     Swal.fire({
  //       title: "Processing Payment",
  //       text: "Please wait while we verify your payment...",
  //       icon: "info",
  //       allowOutsideClick: false,
  //       showConfirmButton: false,
  //       didOpen: () => {
  //         Swal.showLoading();
  //       },
  //     });

  //     const token = localStorage.getItem("accessToken");

  //     if (!token) {
  //       throw new Error("Authentication token not found. Please login again.");
  //     }

  //     // Prepare verification data
  //     const verificationData = {
  //       order_no: orderData.order_no || orderData.id || orderData.order_id,
  //       razorpay_payment_id: paymentResponse.razorpay_payment_id,
  //       razorpay_order_id: paymentResponse.razorpay_order_id,
  //       razorpay_signature: paymentResponse.razorpay_signature,
  //     };

  //     console.log("📤 Sending verification data to backend:", verificationData);

  //     // Verify payment on backend
  //     const verifyResponse = await fetch(
  //       "https://vogelkoparchitects.com/api/ecom/verify-payment/",
  //       {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(verificationData),
  //       },
  //     );

  //     const verifyResult = await verifyResponse.json();
  //     console.log("📥 Verification response:", verifyResult);

  //     // Close processing Swal
  //     Swal.close();

  //     if (verifyResponse.ok) {
  //       // Success - payment verified
  //       await Swal.fire({
  //         title: "🎉 Payment Successful!",
  //         html: `
  //         <div style="text-align: left;">
  //           <p><strong>Order placed successfully!</strong></p>
  //           <p>Order Number: <strong>${orderData.order_no || orderData.id}</strong></p>
  //           <p>Payment ID: <strong>${paymentResponse.razorpay_payment_id}</strong></p>
  //           <p>A confirmation email has been sent to your registered email address.</p>
  //         </div>
  //       `,
  //         icon: "success",
  //         confirmButtonText: "View Orders",
  //         confirmButtonColor: "#3085d6",
  //       }).then((result) => {
  //         if (result.isConfirmed) {
  //           // Clear cart or selected items if needed
  //           // You might want to clear the selected items from localStorage or state
  //           navigate("/orders", {
  //             state: {
  //               orderSuccess: true,
  //               orderId: orderData.order_no || orderData.id,
  //             },
  //           });
  //         }
  //       });
  //     } else {
  //       // Payment verification failed on backend
  //       const errorMessage =
  //         verifyResult.message || "Payment verification failed";

  //       // Log the error for debugging
  //       console.error("❌ Verification failed:", {
  //         status: verifyResponse.status,
  //         statusText: verifyResponse.statusText,
  //         error: verifyResult,
  //       });

  //       // Show appropriate error message based on response
  //       if (verifyResponse.status === 401) {
  //         throw new Error("Session expired. Please login again.");
  //       } else if (verifyResponse.status === 404) {
  //         throw new Error("Order not found. Please contact support.");
  //       } else {
  //         throw new Error(errorMessage);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("❌ Payment verification error:", error);

  //     // Close any open Swal
  //     Swal.close();

  //     // Show error message with retry option
  //     const result = await Swal.fire({
  //       title: "⚠️ Payment Verification Failed",
  //       html: `
  //       <div style="text-align: left;">
  //         <p><strong>${error.message || "Unknown error occurred"}</strong></p>
  //         <p>Your payment may have been successful but we couldn't verify it.</p>
  //         <p>Payment ID: <strong>${paymentResponse?.razorpay_payment_id || "N/A"}</strong></p>
  //         <p>Please save this payment ID for reference.</p>
  //       </div>
  //     `,
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Retry Verification",
  //       cancelButtonText: "Contact Support",
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //     });

  //     if (result.isConfirmed) {
  //       // Retry verification
  //       await handlePaymentSuccess(paymentResponse, orderData);
  //     } else {
  //       // Navigate to support or orders page with payment info
  //       navigate("/contact-support", {
  //         state: {
  //           paymentId: paymentResponse?.razorpay_payment_id,
  //           orderId: orderData.order_no || orderData.id,
  //           error: error.message,
  //         },
  //       });
  //     }
  //   } finally {
  //     setProcessingPayment(false);
  //   }
  // };

  const handlePaymentSuccess = async (paymentResponse, orderData) => {
    try {
      setProcessingPayment(true);

      console.log("✅ Full Razorpay Payment Response:", paymentResponse);
      console.log("📦 Order Data:", orderData);

      // Show processing message
      Swal.fire({
        title: "Processing Payment",
        text: "Please wait while we verify your payment...",
        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const token = localStorage.getItem("accessToken");

      // IMPORTANT: Check if signature exists in paymentResponse
      // The signature might be in a different property or need to be extracted
      const signature =
        paymentResponse.razorpay_signature ||
        paymentResponse.signature ||
        paymentResponse.razorpaySignature ||
        "";

      // Prepare verification data - MUST include all three fields
      const verificationData = {
        order_no: orderData.order_no,
        razorpay_payment_id: paymentResponse.razorpay_payment_id,
        razorpay_order_id:
          orderData.razorpay_order_id || paymentResponse.razorpay_order_id,
        razorpay_signature: signature,
      };

      // Validate all required fields are present
      if (
        !verificationData.razorpay_payment_id ||
        !verificationData.razorpay_order_id ||
        !verificationData.razorpay_signature
      ) {
        console.error("Missing required fields:", {
          hasPaymentId: !!verificationData.razorpay_payment_id,
          hasOrderId: !!verificationData.razorpay_order_id,
          hasSignature: !!verificationData.razorpay_signature,
        });

        throw new Error("Incomplete payment response from Razorpay");
      }

      console.log("📤 Sending verification data:", verificationData);

      // Make the API call
      const verifyResponse = await fetch(
        "https://vogelkoparchitects.com/api/ecom/place-order-after-payment/",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(verificationData),
        },
      );

      const verifyResult = await verifyResponse.json();
      console.log("📥 Verification response:", verifyResult);

      Swal.close();

      if (verifyResponse.ok) {
        // Success
        await Swal.fire({
          title: "🎉 Payment Successful!",
          html: `
          <div style="text-align: left;">
            <p><strong>Order placed successfully!</strong></p>
            <p>Order Number: <strong>${verificationData.order_no}</strong></p>
            <p>Payment ID: <strong>${verificationData.razorpay_payment_id}</strong></p>
          </div>
        `,
          icon: "success",
          confirmButtonText: "View Orders",
        }).then(() => {
          navigate("/orders", {
            state: {
              orderSuccess: true,
              orderId: verificationData.order_no,
            },
          });
        });
      } else {
        // Handle specific error from backend
        const errorMsg =
          verifyResult.error ||
          verifyResult.message ||
          "Payment verification failed";

        if (errorMsg.includes("Payment data missing")) {
          throw new Error(
            "Missing payment signature. Please contact support with your payment ID.",
          );
        } else {
          throw new Error(errorMsg);
        }
      }
    } catch (error) {
      console.error("❌ Payment verification error:", error);

      Swal.close();

      // Show error with retry option

    } finally {
      setProcessingPayment(false);
    }
  };

  // Helper function for successful payment
  // eslint-disable-next-line no-unused-vars
  const handleSuccessfulPayment = async (verificationData, orderData) => {
    await Swal.fire({
      title: "🎉 Payment Successful!",
      html: `
      <div style="text-align: left;">
        <p><strong>Order placed successfully!</strong></p>
        <p>Order Number: <strong>${verificationData.order_no}</strong></p>
        <p>Payment ID: <strong>${verificationData.razorpay_payment_id}</strong></p>
      </div>
    `,
      icon: "success",
      confirmButtonText: "View Orders",
    }).then(() => {
      navigate("/orders", {
        state: {
          orderSuccess: true,
          orderId: verificationData.order_no,
        },
      });
    });
  };
//   const order = {
//   id: "ORD" + Math.floor(Math.random() * 100000),
//   items: cartItems,
//   date: new Date().toLocaleDateString(),
//   status: "Processing",
//   cancelled: false
// };

// let orders = JSON.parse(localStorage.getItem("orders")) || [];

// orders.push(order);

// localStorage.setItem("orders", JSON.stringify(orders));

  // Try alternative endpoints


  // Handle verification error with user-friendly message

  // Validate form
  const validateForm = () => {
    const { shipping_address } = formData;

    // Validate shipping address
    if (
      !shipping_address.name ||
      !shipping_address.email ||
      !shipping_address.mobile ||
      !shipping_address.street ||
      !shipping_address.city ||
      !shipping_address.state ||
      !shipping_address.postal_code
    ) {
      Swal.fire("Error", "Please fill all shipping address fields", "error");
      return false;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(shipping_address.email)) {
      Swal.fire("Error", "Please enter a valid email address", "error");
      return false;
    }

    // Validate mobile number
    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(shipping_address.mobile)) {
      Swal.fire(
        "Error",
        "Please enter a valid 10-digit mobile number",
        "error",
      );
      return false;
    }

    // Validate pincode
    const pincodeRegex = /^[0-9]{6}$/;
    if (!pincodeRegex.test(shipping_address.postal_code)) {
      Swal.fire("Error", "Please enter a valid 6-digit pincode", "error");
      return false;
    }

    // Validate billing address if not same as shipping
    if (!sameAsShipping) {
      const { billing_address } = formData;
      if (
        !billing_address.name ||
        !billing_address.email ||
        !billing_address.mobile ||
        !billing_address.street ||
        !billing_address.city ||
        !billing_address.state ||
        !billing_address.postal_code
      ) {
        Swal.fire("Error", "Please fill all billing address fields", "error");
        return false;
      }

      // Validate billing email
      if (!emailRegex.test(billing_address.email)) {
        Swal.fire(
          "Error",
          "Please enter a valid billing email address",
          "error",
        );
        return false;
      }

      // Validate billing mobile
      if (!mobileRegex.test(billing_address.mobile)) {
        Swal.fire(
          "Error",
          "Please enter a valid 10-digit billing mobile number",
          "error",
        );
        return false;
      }

      // Validate billing pincode
      if (!pincodeRegex.test(billing_address.postal_code)) {
        Swal.fire(
          "Error",
          "Please enter a valid 6-digit billing pincode",
          "error",
        );
        return false;
      }
    }

    // Validate items
    if (!formData.items || formData.items.length === 0) {
      Swal.fire("Error", "No items to order", "error");
      return false;
    }

    return true;
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <>
      <div className="cart-banner">
        <img
          src="/assets/img/ecommerce/banner/banner1.jpg"
          alt="Shopping Cart Banner"
          className="cart-banner-image"
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/1200x250?text=Shopping+Cart";
          }}
        />
        <div className="cart-banner-overlay">
          <div>
            <h1 className="cart-banner-title">Place Your Order</h1>
            <p className="cart-banner-subtitle">
              Complete your purchase securely
            </p>
          </div>
        </div>
      </div>

      <div className="place-order-container">
        <div className="place-order-header">
          <h1>Place Your Order</h1>
          <p>Complete your purchase by providing the details below</p>
        </div>

        <div className="place-order-content">
          {/* Order Summary */}
          <div className="order-summary-sidebar">
            <h2>Order Summary</h2>
            <div className="order-items">
              {selectedItems.map((item) => (
                <div key={item.cart_item_id} className="order-item">
                  <div className="order-item-image">
                    <img
                      src={item.image || "/api/placeholder/60/60"}
                      alt={item.product_name}
                    />
                  </div>
                  <div className="order-item-details">
                    <h4>{item.product_name}</h4>
                    <p>Qty: {item.quantity}</p>
                    <p className="order-item-price">
                      {formatCurrency(item.total_price)}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="order-total">
              <div className="total-row">
                <span>Subtotal ({itemCount} items)</span>
                <span>{formatCurrency(totalAmount)}</span>
              </div>
              <div className="total-row shipping">
                <span>Shipping</span>
                <span>Free</span>
              </div>
              <div className="total-row grand-total">
                <span>Total</span>
                <span>{formatCurrency(totalAmount)}</span>
              </div>
            </div>
          </div>

          {/* Address Form */}
          <div className="address-form-container">
            <form onSubmit={handlePlaceOrder}>
              {/* Shipping Address */}
              <div className="form-section">
                <h3>Shipping Address</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      value={formData.shipping_address.name}
                      onChange={(e) =>
                        handleInputChange(e, "shipping_address", "name")
                      }
                      required
                      placeholder="Mugilesh A"
                    />
                  </div>
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      value={formData.shipping_address.email}
                      onChange={(e) =>
                        handleInputChange(e, "shipping_address", "email")
                      }
                      required
                      placeholder="guest@example.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Mobile Number *</label>
                    <input
                      type="tel"
                      value={formData.shipping_address.mobile}
                      onChange={(e) =>
                        handleInputChange(e, "shipping_address", "mobile")
                      }
                      required
                      placeholder="9876543210"
                      pattern="[0-9]{10}"
                      maxLength="10"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Street Address *</label>
                  <input
                    type="text"
                    value={formData.shipping_address.street}
                    onChange={(e) =>
                      handleInputChange(e, "shipping_address", "street")
                    }
                    required
                    placeholder="12 MG Road"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>City *</label>
                    <input
                      type="text"
                      value={formData.shipping_address.city}
                      onChange={(e) =>
                        handleInputChange(e, "shipping_address", "city")
                      }
                      required
                      placeholder="Chennai"
                    />
                  </div>
                  <div className="form-group">
                    <label>State *</label>
                    <input
                      type="text"
                      value={formData.shipping_address.state}
                      onChange={(e) =>
                        handleInputChange(e, "shipping_address", "state")
                      }
                      required
                      placeholder="Tamil Nadu"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Postal Code *</label>
                    <input
                      type="text"
                      value={formData.shipping_address.postal_code}
                      onChange={(e) =>
                        handleInputChange(e, "shipping_address", "postal_code")
                      }
                      required
                      placeholder="600001"
                      pattern="[0-9]{6}"
                      maxLength="6"
                    />
                  </div>
                  <div className="form-group">
                    <label>Country</label>
                    <input
                      type="text"
                      value={formData.shipping_address.country}
                      disabled
                      className="disabled-input"
                    />
                  </div>
                </div>
              </div>

              {/* Billing Address */}
              <div className="form-section">
                <div className="checkbox-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={sameAsShipping}
                      onChange={handleSameAsShipping}
                    />
                    <span>Billing address same as shipping address</span>
                  </label>
                </div>

                {!sameAsShipping && (
                  <div className="billing-address-form">
                    <h3>Billing Address</h3>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Full Name *</label>
                        <input
                          type="text"
                          value={formData.billing_address.name}
                          onChange={(e) =>
                            handleInputChange(e, "billing_address", "name")
                          }
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Email *</label>
                        <input
                          type="email"
                          value={formData.billing_address.email}
                          onChange={(e) =>
                            handleInputChange(e, "billing_address", "email")
                          }
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Mobile Number *</label>
                        <input
                          type="tel"
                          value={formData.billing_address.mobile}
                          onChange={(e) =>
                            handleInputChange(e, "billing_address", "mobile")
                          }
                          required
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Street Address *</label>
                      <input
                        type="text"
                        value={formData.billing_address.street}
                        onChange={(e) =>
                          handleInputChange(e, "billing_address", "street")
                        }
                        required
                      />
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>City *</label>
                        <input
                          type="text"
                          value={formData.billing_address.city}
                          onChange={(e) =>
                            handleInputChange(e, "billing_address", "city")
                          }
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>State *</label>
                        <input
                          type="text"
                          value={formData.billing_address.state}
                          onChange={(e) =>
                            handleInputChange(e, "billing_address", "state")
                          }
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Postal Code *</label>
                        <input
                          type="text"
                          value={formData.billing_address.postal_code}
                          onChange={(e) =>
                            handleInputChange(
                              e,
                              "billing_address",
                              "postal_code",
                            )
                          }
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Country</label>
                        <input
                          type="text"
                          value={formData.billing_address.country}
                          disabled
                          className="disabled-input"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div className="form-actions">
                <button
                  type="button"
                  className="back-btn"
                  onClick={() => navigate("/cart")}
                  disabled={loading || processingPayment}
                >
                  Back to Cart
                </button>
                <button
                  type="submit"
                  className="place-order-btn"
                  disabled={loading || processingPayment}
                >
                  {loading
                    ? "Creating Order..."
                    : processingPayment
                      ? "Payment in Progress..."
                      : `Pay ${formatCurrency(totalAmount)}`}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Placeorder;
